import SpotifyWebApi from "../_snowpack/pkg/spotify-web-api-js.js";
export const spotifyApi = new SpotifyWebApi();
